const inquiryMainWrap = () => import("@/views/main_wrap.vue");

const createInquiryViewRoute = ({ path, name, component, aliases = [] }) => ({
    path,
    name,
    alias: aliases,
    component: inquiryMainWrap,
    children: [
        {
            path: "",
            component
        }
    ]
});

export const inquiryRoutes = [
    createInquiryViewRoute({
        path: "/inquiry/customer-center",
        name: "Gsrcu01",
        aliases: [
            "/gsrcu01",
            "/inquiry/gsrcu01"
        ],
        component: () => import("@/views/inquiry/01/gsrcu01.vue")
    })
];
